import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo4_Bernardo } from '../../../../../utils/ES/Modals/directors';

const ModalVideoBernardo4 = () => {
  return (
    <>
      <ModalVideo
        id="bernardo-video-4"
        dataText={TextVideo4_Bernardo}
        videoSrc="https://player.vimeo.com/video/197534686?h=9fa34c35f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_BERNARDO_4"
      />
    </>
  );
};

export default ModalVideoBernardo4;
